import { NgFor, NgForOf, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TFMService } from 'app/mock-api/tfm.service';
import { DropzoneConfigInterface, DropzoneModule } from 'ngx-dropzone-wrapper';
import { NgxDropzoneModule } from 'ngx-dropzone';

@Component({
  selector: 'app-uploader',
  standalone: true,
  imports: [NgxDropzoneModule,DropzoneModule,NgFor,NgIf],
  templateUrl: './uploader.component.html',
  styleUrl: './uploader.component.scss'
})
export class UploaderComponent {
  @Input() type : string = "site";
  @Input() group : string = "";
  @Input() parentIdentifier : string = "";
  @Input() typeIdentifier : string = "";
  @Input() description : string = "Drop/click to upload multiple files...";
  @Input() classWidth : string = "col-md-3";
  @Input() autoReset : number = 1;
  @Input() purpose : string = "";

  @Output() onSelect = new EventEmitter<any>();

  public view : any = {};

  public config: DropzoneConfigInterface = {
    clickable: true,
    maxFiles: 5,
    autoReset: 1,
    errorReset: 1,
    cancelReset: 1,
    acceptedFiles:"image/*,.pdf"
  };

  constructor(private tfmService:TFMService, private sanitizer: DomSanitizer) {
    this.config.autoReset = this.autoReset;
  }

  ngOnInit(): void {
    if (this.type == "site"){
      this.tfmService.getSite().then(res => {
        //Set upload url
        var link = this.tfmService.getLink(res._links, "site-images");
        this.config.url = link.href + "/" + this.group;
      });
    }
    else {
      this.tfmService.getVersion().subscribe(res => {
        //Set upload url
        var link = this.tfmService.getLink(res._links, this.type + "-images");
        if (link)
          this.config.url = link.href + "/" + this.typeIdentifier;
      });
    }

    this.getImages();
  }

  getImages() {
    var localAgencySite = this.tfmService.getLocalAgencySite();

    if (this.type == "site"){
      this.tfmService.getSiteImages(this.group).subscribe(res => {
        this.view.images = res.content;
      });
    }
    else if (this.type == "supplier") {
      if (this.group == "factsheet") {
        
      }
      else {
        this.tfmService.getSuppliers(localAgencySite.agencyID,localAgencySite.siteID, this.typeIdentifier).subscribe(res=>{
          this.tfmService.filterAndSend(res._links, "images").subscribe(res =>{
            var images = res.content;
            this.setImages(images);
            this.view.images = images;
          });
        });
      }
    }
    else if (this.type == "service") {
      this.tfmService.getServiceByGuid(localAgencySite.agencyID, localAgencySite.siteID, this.parentIdentifier, this.typeIdentifier).subscribe(res=>{
        console.log("service", res);
        this.tfmService.filterAndSend(res.content._links, "images").subscribe(res =>{
          var images = res.content;
          this.setImages(images);
          this.view.images = images;
        });
      });
    }
    else if (this.type == "content") {
      this.tfmService.getContent(this.typeIdentifier, localAgencySite.agencyID,localAgencySite.siteID).subscribe(res=>{
        this.tfmService.filterAndSend(res._links, "images").subscribe(res =>{
          var images = res.content;
          this.setImages(images);
          this.view.images = images;
        });
      });
    }
    else if (this.type == "package") {
      this.tfmService.getItin(this.typeIdentifier).subscribe(res=>{
        this.tfmService.filterAndSend(res.content.itinerary._links, "images").subscribe(res =>{
          var images = res.content;
          this.setImages(images);
          this.view.images = images;
        });
      });
    }
  }
  setImages(images) {
    images.forEach(image => {
      image.urlText = this.tfmService.getLink(image._links, "view").href;
      image.url = this.sanitizer.bypassSecurityTrustUrl(this.tfmService.getLink(image._links, "view").href);
      image.urlBg = this.sanitizer.bypassSecurityTrustStyle('url(' + this.tfmService.getLink(image._links, "view").href + ')');
    });
  }
  selectImage(image) {
    console.log(image);
    this.onSelect.emit(image);
  }
  toggleFeaturedImage(image) {
    this.tfmService.filterAndSend(image._links, "toggle-featured").subscribe(res => {
      console.log("Image featured state changed");
      this.getImages();
    });
  }
  toggleActiveImage(image) {
    this.tfmService.filterAndSend(image._links, "toggle-active").subscribe(res => {
      console.log("Image active state changed");
      this.getImages();
    });
  }
  removeImage(image) {
    this.tfmService.filterAndSend(image._links, "delete").subscribe(res => {
      console.log("Image deleted");
      this.getImages();
    });
  }

  public onUploadInit(args: any): void {
    console.log('onUploadInit:', args);
  }

  public onUploadError(args: any): void {
    console.log('onUploadError:', args);
  }

  public onUploadSuccess(args: any): void {
    console.log('onUploadSuccess:', args);

    this.getImages();
  }


}
